export const isBeverageDataValid = (details) => {
  const entries = Object.values(details);
  return entries.length > 0 && entries.every((detail) => detail.types?.length);
};
